import { useCallback } from 'react';
import { useAxios } from '../axios';
import { Container, GetContainerParams } from './container.types';

export const useGetContainer = () => {
  const [{ data, loading }, axiosFetch] = useAxios<{
    result: { data: Container[]; count: number };
  }>({
    method: 'GET',
  });

  const getContainer = useCallback(
    ({
      filterText = '',
      pageNumber = 1,
      resultSize = 25,
      withSystemUsers = false,
    }: GetContainerParams) =>
      axiosFetch({
        url: '/container',
        params: {
          filterText,
          pageNumber,
          resultSize,
          withSystemUsers,
        },
      }),
    [axiosFetch],
  );

  return {
    data: data?.result.data,
    loading,
    getContainer,
  };
};
